import React, { useState, useEffect, useRef } from "react";
import Services from "../../utils/services";
import GenAIAuthoring2Home from '../../components/GenAIAnswering2.0/GenAIAuthoring2.0Home'
import { useHistory } from "react-router";

function GenAIAuthoring2() {
    const [customWidth, setCustomWidth] = useState(window.innerWidth);
    const [customHeight, setCustomHeight] = useState(window.innerHeight);
    const useridRef = useRef('');
    const history = useHistory();
    useEffect(() => {
        const initializePage = async () => {
            try {
                document.title = 'iMedical Search';
                window.scrollTo(0, 0);

                useridRef.current = JSON.parse(localStorage.getItem('username')) || '';
                let userExists = localStorage.getItem('userExists');
                let service = new Services();
                if (useridRef.current) {
                    service.logService(`Gen AI Authoring 2 page successfully mounted for ${useridRef.current.toLowerCase()}`, 'info');
                }
                if (!userExists) {
                    console.log('Access Denied');
                    history.push('/');
                }

            } catch (error) {

            }
        };

        initializePage();
    }, [history]);
    useEffect(() => {
        const updateDimensions = () => {
            setCustomWidth(window.innerWidth);
            setCustomHeight(window.innerHeight)
        }
        // Add event listener
        window.addEventListener('resize', updateDimensions);
        // Cleanup function: remove event listener when component unmounts
        return () => {
            let service = new Services();
            window.removeEventListener('resize', updateDimensions);
            if (useridRef.current) {
                service.logService(`Gen AI Authoring 2 page successfully unmounted for ${useridRef.current.toLowerCase()}`, 'info')
            }
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount


    return (
        <GenAIAuthoring2Home customWidth={customWidth} customHeight={customHeight} />)
}
export default GenAIAuthoring2;